import React, { useState } from 'react'
import styles from './ProfileCard.module.scss'

export default function ProfileCard({ user }) {
  const fullName   = [user?.surName, user?.firstName, user?.lastName].filter(Boolean).join(' ')
  const initials   = [user?.firstName?.[0], user?.surName?.[0]].filter(Boolean).join('').toUpperCase()
  const position   = user?.position || 'Сотрудник'
  const phone      = user?.numberPhone || user?.number_phone || '—'
  const department = user?.department || user?.department_name || null
  const photoSrc   = user?.imeag || user?.image || null

  const [imgErr, setImgErr] = useState(false)
  const showPhoto = photoSrc && !imgErr

  return (
    <div className={styles.card}>
      <div className={styles.avatar} style={showPhoto ? { background: 'transparent', padding: 0 } : undefined}>
        {showPhoto
          ? <img src={photoSrc} alt={fullName} className={styles.avatarImg} onError={() => setImgErr(true)} />
          : (initials || '👤')
        }
      </div>
      <div className={styles.info}>
        <p className={styles.name}>{fullName || '—'}</p>
        <div className={styles.badgeRow}>
          <span className={styles.positionBadge}>{position}</span>
          {department && <span className={styles.deptBadge}>{department}</span>}
        </div>
      </div>
      <div className={styles.meta}>
        <div className={styles.metaItem}>
          <span className={styles.metaIcon}>📞</span>
          <div className={styles.metaText}>
            <span className={styles.metaLabel}>Телефон</span>
            <span className={styles.metaValue}>{phone}</span>
          </div>
        </div>
        {department && (
          <div className={styles.metaItem}>
            <span className={styles.metaIcon}>🏢</span>
            <div className={styles.metaText}>
              <span className={styles.metaLabel}>Отдел</span>
              <span className={styles.metaValue}>{department}</span>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
